import { Box } from '@material-ui/core';
import { formatDateTimeReadable } from '@nemuru-eng/js-api-client';

import { ProgressStep } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/entities/Progress/_shared/types';
import { AbstractProgress } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/entities/Progress/AbstractProgress';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

import { StepStatusIcon } from './StepStatusIcon';

interface ApplicationStepProps {
  step: ProgressStep;
  progress: AbstractProgress;
}

export const ApplicationStep = ({ step, progress }: ApplicationStepProps) => {
  const stepDetails = progress.getProgressStepDetails(step);

  if (!stepDetails || step.isHidden) {
    return null;
  }

  return (
    <>
      <Box
        width={'100%'}
        display={'flex'}
        flexDirection={'row'}
        justifyContent={'space-between'}
        alignItems={'center'}
        style={{ height: 28 }}
      >
        <Box display={'flex'} flexDirection={'row'} alignItems={'center'} height={'100%'}>
          <StepStatusIcon stepStatus={stepDetails.status} />
          <Font variant={'body2'} color={'textSecondary'}>
            <Text tId={stepDetails.name} />
          </Font>
        </Box>
        {stepDetails.updatedAt && (
          <Box>
            <Font variant={'caption'} color={'textSecondary'}>
              {formatDateTimeReadable(stepDetails.updatedAt)}
            </Font>
          </Box>
        )}
      </Box>
    </>
  );
};
